<template>
  <div class="downloads">
    <Header isAbout="true" />
    <div class="container">
      <section>
        <h1><img src="../../assets/images/title-downloads.svg" alt="Downloads">
          <span>ブランドアセットをダウンロード</span>
        </h1>
        <router-view />
      </section>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../Molecules/Header'
import Footer from '../Molecules/Footer'

export default {
  name: 'Downloads',
  components: {
    Header,
    Footer
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.downloads {
  width: 100%;
}

section {
  width: 100%;
  margin: 0 auto;
  padding: 14.4rem 14.4rem;
  text-align: left;
  box-sizing: border-box;
}

@media screen and (max-width: 1440px) {
  section {
    padding: 14.4rem 9.6rem;
  }
}

@media screen and (max-width: 1024px) {
  section {
    padding: 14.4rem 7.2rem;
  }
}

h1 img {
  width: 100%;
  max-width: 68.7rem;
  height: auto;
}

h1 span {
  margin: 4.8rem 0;
  font-size: var(--extra-jumbo-font-size);
  font-weight: var(--bold-font-weight);
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Downloads.vue